<template>
  <div id="invigilate-setup">
    <h1>Invigilation Setup</h1>

    <p>
      This exam is invigilated, meaning that your audio, webcam video, and screen will be recorded during the
      exam, and will be controlled to ensure the integrity of the exam before finalizing the result.
    </p>

    <div v-if="!forceDesktopFulfilled">
      <p class="invigilate-not-fulfilled">Unsupported Device!</p>
      <p>
        Invigilation is not supported on tablets and mobile phones. Please use your laptop or desktop computer
        instead.
      </p>
      <br />
      <button @click="showDashboard">Back</button>
    </div>

    <div v-else>
      <p>The following requirements must be fulfilled before you can start an invigilated exam:</p>

      <h3 class="passed">1. Device</h3>
      <p>You must use your laptop or desktop computer. Tablets and mobile phones are not supported.</p>

      <h3 :class="{ passed: browserFulfilled }">2. Browser</h3>
      <p>
        Unlike other exams, only the new versions of the Chrome browser is supported for invigilated exams.<br />If
        you use extra security or privacy plugins, disable them for this website to ensure there will not be a
        problem during the exam.
      </p>

      <WebcamSetup />

      <AudioSetup />

      <ScreenRecorderSetup />

      <UserPictureSetup v-if="!flags.middle_of_exam" />

      <button @click="showDashboard">Done</button>
    </div>
  </div>
</template>

<script>
import WebcamSetup from './WebcamSetup'
import ScreenRecorderSetup from './ScreenRecorderSetup'
import UserPictureSetup from './UserPictureSetup'
import AudioSetup from './AudioSetup'
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState(['flags']),
    ...mapGetters('invigilate', ['forceDesktopFulfilled', 'browserFulfilled']),
  },
  components: {
    WebcamSetup,
    ScreenRecorderSetup,
    UserPictureSetup,
    AudioSetup,
  },
  methods: {
    showDashboard() {
      this.$store.dispatch('initializeApp')
    },
  },

  mounted() {
    // console.log('browser')
    // console.log(xx.browser)
  },
}
</script>
